export default __webpack_public_path__ + "static/media/Guide1.56b5707b.jpg";